export function getFileExtension(fileName: string) {
  return (fileName.match(/\.?([^.]+)$/) ?? [])[1] ?? '';
}
